import styles from "./loading.module.scss";
import { Spin } from "antd";
const Loading = ({ isOpen, text = "", callback = {} }) => {
  return (
    <>
      {isOpen && (
        <div className={styles.loading_overlay}>
          <Spin spinning={isOpen} size="large" tip={text}></Spin>
        </div>
      )}
    </>
  );
};

export default Loading;
